import { Component, OnInit, OnDestroy } from '@angular/core';
import { switchMap, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { UserInfo } from 'firebase';

import { AuthenticationService } from 'src/app/auth/fire-auth/authentication.service';
import { FeedService } from 'src/app/core/feed/services/feed.service';
import { UserfirestoreService } from 'src/app/auth/fire-store/userfirestore.service';
import { Status } from './../../constants';
import { User } from 'src/app/models/user';

@Component({
  selector: 'makaw-private-profile',
  templateUrl: './private-profile.component.html',
})
export class PrivateProfileComponent implements OnInit, OnDestroy {
  private destroyed$ = new Subject();
  public posts$;
  public currentUser: User;
  public status = Status.Owner;

  constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly feedService: FeedService,
    private readonly userService: UserfirestoreService
  ) {}

  ngOnInit() {
    this.authenticationService
      .getStatus()
      .pipe(
        switchMap((status: UserInfo) =>
          this.userService.getUserById(status.uid).valueChanges()
        ),
        switchMap((currentUser: User) => {
          this.currentUser = currentUser;
          return (this.posts$ = this.feedService.getUserPost(currentUser.uid));
        }),
        takeUntil(this.destroyed$)
      )
      .subscribe();
  }
  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
